// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mpgh8","type":"styles_type__2M3xj","choices":"styles_choices__30BZj"};